
export const navigateStart = (data: any) => ({
    type: 'NAVIGATE_START',
    payload: data,
});


export const changeLanguage = (language:string,currency:string,dateFormat:string, thousandSeparater?:string, decimalSeparater?: string) => ({
    type:'CHANGE_LANGUAGE',
    language:language,
    currency:currency,
    dateFormat:dateFormat,
    thousandSeparater: thousandSeparater,
    decimalSeparater: decimalSeparater
});

export const changeRegionalSettings = (regionalSettings: any) => ({
    type: 'CHANGE_REGIONAL_SETTINGS',
    payload: regionalSettings,
});
